import { useLocale } from "@dgs/core";
import { intlFormatDistance, isToday } from "date-fns";
import { FC } from "react";
import { useTranslation } from "react-i18next";

export const BirthdateDistance: FC<{ date: string }> = ({ date }) => {
	const { formatLocale } = useLocale();
	const { t } = useTranslation();

	return isToday(new Date(date))
		? t("Today")
		: intlFormatDistance(new Date(date), new Date(), { locale: formatLocale });
};
